// Google Analytics 4 (gtag.js). Loads on every page; uses Consent Mode so
// nothing is stored until the visitor accepts cookies in CookieConsent.
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const CONSENT_STORAGE_KEY = "coreshift-cookie-consent";

const measurementId = import.meta.env.VITE_LOVABLE_CONNECTOR_GOOGLE_ANALYTICS_API_KEY as string | undefined;

export function initAnalytics() {
  if (!measurementId || typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params -- gtag.js needs the Arguments object
    window.dataLayer.push(arguments);
  };

  const accepted = window.localStorage.getItem(CONSENT_STORAGE_KEY) === "accepted";
  window.gtag("consent", "default", {
    analytics_storage: accepted ? "granted" : "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  window.gtag("set", "developer_id.dZjgwMW", true);
  window.gtag("js", new Date());
  window.gtag("config", measurementId);

  // index.html already includes the gtag.js loader; only add it if missing
  // (e.g. a page served without the built template).
  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  }
}

export function updateAnalyticsConsent(choice: "accepted" | "declined") {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("consent", "update", {
    analytics_storage: choice === "accepted" ? "granted" : "denied",
  });
}

/** Send a page view on client-side route changes (first load is sent by config). */
export function trackPageView(path: string) {
  if (typeof window === "undefined" || !window.gtag || !measurementId) return;
  window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
}
